import { render, staticRenderFns } from "./Uploaderimage.vue?vue&type=template&id=8a5b61a2&"
import script from "./Uploaderimage.vue?vue&type=script&lang=js&"
export * from "./Uploaderimage.vue?vue&type=script&lang=js&"
import style0 from "./Uploaderimage.vue?vue&type=style&index=0&id=8a5b61a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports